<script setup lang="ts" generic="T extends Pick<Project, 'logos' | 'name' | 'integrations'>">
import { image } from '@/utils/image';
import { projectType } from '@/utils/projectType';
import { FontAwesomeIcon, TmlImage } from '@teemill/components';
import type { Project } from '@teemill/projects';
import { computed } from 'vue';

const props = defineProps<{
  project: T;
}>();

const logo = computed(() => props.project.logos.find((logo) => logo.meta.context === 'dashboard'));
</script>

<template>
  <div
    class="overflow-hidden text-gray-600 p-1 flex items-center justify-center rounded-[--tml-inner-radius]"
    :style="{
      backgroundColor: logo?.meta.backgroundColor || '#fff',
    }"
  >
    <TmlImage
      v-if="logo?.url"
      :src="image(logo.url).srcset(['webp', 'png', 'jpeg'])"
      fit="contain"
      :alt="`${project.name} logo`"
      class="max-w-[130px] max-h-[150px] w-full h-full"
    />
    <div v-else class="flex justify-center items-center max-w-[36px] max-h-[32px] m-1">
      <FontAwesomeIcon class="m-auto w-full h-full" :icon="projectType(project).icon" />
    </div>
  </div>
</template>
